import * as XLSX from 'xlsx';
import { FEEDBACK_EXPORT_WORKBOOK_SHEETS } from '../services/feedbackExportData';
import { alignExportRows } from './feedbackExportFlatten';
import { decodeResearchConsentFlatRow } from './exportConsentSheetValues';
import { encodeWorkplaceSurveyExportRow } from './exportWorkplaceSurveyValues';

/**
 * @param {Record<string, Array<Record<string, unknown>>>} payload - keys match sheetTitle from FEEDBACK_EXPORT_COLLECTIONS
 * @param {string} [filenamePrefix]
 */
export function downloadFeedbackExportXlsx(payload, filenamePrefix = 'lotus-lms-feedback') {
  const wb = XLSX.utils.book_new();
  for (const sheetTitle of FEEDBACK_EXPORT_WORKBOOK_SHEETS) {
    const docs = payload[sheetTitle] || [];
    const rows = alignExportRows(docs, {
      transformFlatRow:
        sheetTitle === 'Workplace surveys'
          ? encodeWorkplaceSurveyExportRow
          : sheetTitle === 'Research consent'
            ? decodeResearchConsentFlatRow
            : undefined,
    });
    const ws = XLSX.utils.json_to_sheet(rows);
    const safeName = sheetTitle.slice(0, 31);
    XLSX.utils.book_append_sheet(wb, ws, safeName);
  }
  const d = new Date();
  const stamp = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  XLSX.writeFile(wb, `${filenamePrefix}-${stamp}.xlsx`);
}
